<ng-container *ngIf="description" [ngTemplateOutlet]="card"></ng-container>
<a *ngIf="!description" [airLink]="unifiedLink" [userEventSource]="userEventSource">
  <ng-container [ngTemplateOutlet]="card"></ng-container>
</a>

<ng-template #card>
  <div [ngClass]="{ 'card--overlap': !description }">
    <div class="card__image">
      <figure *ngIf="image">
        <air-focal-image [image]="image" [isCropped]="false"></air-focal-image>
      </figure>
    </div>
    <div *ngIf="description" class="card__text">
      <h4>{{ title }}</h4>
      <div *ngIf="description" class="card__description">
        <p>{{ description }}</p>
      </div>
    </div>
    <div class="card__cta" [ngClass]="{ 'card__cta--overlap': !description }" *ngIf="unifiedLink">
      <a [airLink]="unifiedLink" [userEventSource]="userEventSource" class="button button--cta">
        <span>{{ description ? unifiedLink.label : title }}</span>
      </a>
    </div>
    <div *ngIf="step" class="card__step">
      <p class="h1">{{ step }}</p>
    </div>
  </div>
</ng-template>
